const isTypeOptional = (singleType: string) => singleType.trim().endsWith('?');

export default isTypeOptional;
